import { createNotificationsApi } from '@roselabs-io/saas-shell'
import { platformApiClient } from './client'

// Create notifications API using saas-shell factory
export const notificationsApi = createNotificationsApi({
  platformApiClient,
})
